class WishlistDrawer extends HTMLElement {
  constructor() {
    super();

    this.wishlistTrigger = document.querySelector('[data-wishlist-trigger]')
    this.wishlistBubble = document.querySelector('[data-wishlist-trigger-bubble]')
    this.productIdData = window.localStorage.getItem('wishlist-ids') || null
    this.productTitleData = window.localStorage.getItem('wishlist-titles') || null
    this.productUrlData = window.localStorage.getItem('wishlist-urls') || null
    this.productMaterialData = window.localStorage.getItem('wishlist-materials') || null
    this.productPriceData = window.localStorage.getItem('wishlist-prices') || null
    this.productImageData = window.localStorage.getItem('wishlist-images') || null

    this.wishlistButtons = document.querySelectorAll('[data-wishlist-product-title]')
    this.wishlistIsEmptyEl = this.querySelector('[data-wishlist-is-empty]')
    this.wishlistDrawerItems = this.querySelector('[data-wishlist-drawer-items]')
    this.wishlistDrawerContent = this.querySelector('[data-wishlist-drawer-body]')
    this.wishlistDrawerListItem = this.querySelector('[data-wishlist-drawer-last-item]')

    if (typeof this.wishlistTrigger === 'undefined' || this.wishlistTrigger === null) { return }

    this.initWishlistButtons()
    this.updateBubbleCount()
    this.handleAccessibilityOpen()
    this.handleCloseDrawer()
    this.initWishlist()
  }

  initWishlist () {
    if (this.productTitleData === null || this.productTitleData === '') {
      this.renderEmptyContent(true)
    } else {
      this.renderContents()
    }
  }

  updateHeartStatuses () {
    const productIds = this.productIdData === null || this.productIdData === ''
      ? ''
      : this.productIdData.split(',')

    this.wishlistButtons.forEach(button => {
      const productId = button.getAttribute('data-wishlist-product-id')
      const inFavourites = productIds.includes(productId)
      const heartStroke = button.querySelector('[data-wishlist-heart-stroke]')
      const heartFill = button.querySelector('[data-wishlist-heart-fill]')

      // Display heart statuses
      heartStroke.classList.toggle('hidden', inFavourites)
      heartFill.classList.toggle('hidden', !inFavourites)
    })
  }

  initWishlistButtons () {
    if (typeof this.wishlistButtons === 'undefined' || this.wishlistButtons === null) { return }

    this.updateHeartStatuses ()

    this.wishlistButtons.forEach(button => {
      const productId = button.getAttribute('data-wishlist-product-id')
      const productTitle = button.getAttribute('data-wishlist-product-title')
      const productUrl = button.getAttribute('data-wishlist-product-url')
      const productMaterial = button.getAttribute('data-wishlist-product-material')
      const productPrice = button.getAttribute('data-wishlist-product-price')
      const productImage = button.getAttribute('data-wishlist-product-image')
      const heartStroke = button.querySelector('[data-wishlist-heart-stroke]')
      const heartFill = button.querySelector('[data-wishlist-heart-fill]')

      button.addEventListener('click', () => {
        // this is already hearted and in our wishlist - remove it
        if (heartStroke.classList.contains('hidden') && this.productIdData.includes(productId)) {
          if (window.localStorage.getItem('wishlist-ids') && window.localStorage.getItem('wishlist-ids').split(',').length <= 2) {
            this.productIdData = ''
            this.productTitleData = ''
            this.productUrlData = ''
            this.productMaterialData = ''
            this.productPriceData = ''
            this.productImageData = ''

            this.renderEmptyContent(true)
          } else {
            this.productIdData = window.localStorage.getItem('wishlist-ids').replace(`${productId},`, '')
            this.productTitleData = window.localStorage.getItem('wishlist-titles').replace(`${productTitle},`, '')
            this.productUrlData = window.localStorage.getItem('wishlist-urls').replace(`${productUrl},`, '')
            this.productMaterialData = window.localStorage.getItem('wishlist-materials').replace(`${productMaterial},`, '')
            this.productPriceData = window.localStorage.getItem('wishlist-prices').replace(`${productPrice},`, '')
            this.productImageData = window.localStorage.getItem('wishlist-images').replace(`${productImage},`, '')
          }
        // this is not hearted and not in our wishlist - add it
        } else if (!heartStroke.classList.contains('hidden')) {
          this.productIdData = this.productIdData && !this.productIdData.includes(productId)
            ? window.localStorage.getItem('wishlist-ids') + productId + ','
            : productId + ','
          this.productTitleData = this.productTitleData && !this.productTitleData.includes(productId)
            ? window.localStorage.getItem('wishlist-titles') + productTitle + ','
            : productTitle + ','
          this.productUrlData = this.productUrlData && !this.productUrlData.includes(productId)
            ? window.localStorage.getItem('wishlist-urls') + productUrl + ','
            : productUrl + ','
          this.productMaterialData = this.productMaterialData && !this.productMaterialData.includes(productId)
            ? window.localStorage.getItem('wishlist-materials') + productMaterial + ','
            : productMaterial + ','
          this.productPriceData = this.productPriceData && !this.productPriceData.includes(productId)
            ? window.localStorage.getItem('wishlist-prices') + productPrice + ','
            : productPrice + ','
          this.productImageData = this.productImageData && !this.productImageData.includes(productId)
            ? window.localStorage.getItem('wishlist-images') + productImage + ','
            : productImage + ','
        }
        window.localStorage.setItem('wishlist-ids', this.productIdData)
        window.localStorage.setItem('wishlist-titles', this.productTitleData)
        window.localStorage.setItem('wishlist-urls', this.productUrlData)
        window.localStorage.setItem('wishlist-materials', this.productMaterialData)
        window.localStorage.setItem('wishlist-prices', this.productPriceData)
        window.localStorage.setItem('wishlist-images', this.productImageData)

        heartStroke.classList.toggle('hidden')
        heartFill.classList.toggle('hidden')

        this.updateBubbleCount()
        this.renderContents()
      })
    })
  }

  handleCloseDrawer () {
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close())
    this.querySelector('#WishlistDrawer-Overlay').addEventListener('click', this.close.bind(this))
  }

  handleAccessibilityOpen () {
    this.wishlistTrigger.setAttribute('role', 'button')
    this.wishlistTrigger.setAttribute('aria-haspopup', 'dialog')
    this.wishlistTrigger.addEventListener('click', () => {
      this.open(this.wishlistTrigger)
    })

    this.wishlistTrigger.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault()
        this.open(this.wishlistTrigger)
      }
    })
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const WishlistDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (WishlistDrawerNote && !WishlistDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(WishlistDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('WishlistDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(WishlistDrawerNote) {
    WishlistDrawerNote.setAttribute('role', 'button');
    WishlistDrawerNote.setAttribute('aria-expanded', 'false');

    if (WishlistDrawerNote.nextElementSibling.getAttribute('id')) {
      WishlistDrawerNote.setAttribute('aria-controls', WishlistDrawerNote.nextElementSibling.id);
    }

    WishlistDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    WishlistDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderEmptyContent (isEmpty) {
    this.wishlistIsEmptyEl.classList.toggle('hidden', !isEmpty)
    this.wishlistDrawerItems.classList.toggle('hidden', isEmpty)
    this.wishlistBubble.classList.toggle('hidden', isEmpty)
  }

  updateBubbleCount () {
    const count = this.productIdData
      ? this.productIdData.split(',').length - 1
      : 0
    this.wishlistBubble.innerHTML = `<span>${count}</span>`
  }

  renderContents () {
    if (this.productTitleData === null || this.productTitleData === '') { return }

    const productIdArr = this.productIdData.split(',')
    const productTitleArr = this.productTitleData.split(',')
    const productUrlArr = this.productUrlData.split(',')
    const productMaterialArr = this.productMaterialData.split(',')
    const productPriceArr = this.productPriceData.split(',')
    const productImageArr = this.productImageData.split(',')

    const wishlistDrawerContent = this.querySelector('[data-wishlist-drawer-body]')
    wishlistDrawerContent.innerHTML = ''
    wishlistDrawerContent.appendChild(this.wishlistDrawerListItem)

    for (let i = 0; i < productTitleArr.length; i++) {
      let newLineItem = document.createElement('tr')
      newLineItem.classList.add('wishlist-item')

      if (productTitleArr[i] !== null && productTitleArr[i] !== 'null' && productTitleArr[i] !== '') {
        newLineItem.innerHTML = this.renderLineItem(productIdArr[i], productTitleArr[i], productUrlArr[i], productMaterialArr[i], productPriceArr[i], productImageArr[i])
        wishlistDrawerContent.insertBefore(newLineItem, this.wishlistDrawerListItem)
      }
    }

    this.renderEmptyContent(false)
    this.initRemoveButtons()
  }

  initRemoveButtons () {
    const removeButtons = this.wishlistDrawerContent.querySelectorAll('[data-wishlist-remove]')

    if (typeof removeButtons === 'undefined' || removeButtons === null) { return }

    const isNowEmpty = () => {
      const updatedRemoveButtons = this.wishlistDrawerContent.querySelectorAll('[data-wishlist-remove]')
      if (typeof updatedRemoveButtons === 'undefined' || updatedRemoveButtons === null || !updatedRemoveButtons || updatedRemoveButtons.length === 0) {
        return true
      }
      return false
    }
    removeButtons.forEach(button => {
      button.addEventListener('click', () => {
        const parentEl = button.closest('.wishlist-item')
        parentEl.remove()

        // Remove from session stoarage
        const productId = button.getAttribute('data-wishlist-product-id')
        const productTitle = button.getAttribute('data-wishlist-product-title')
        const productUrl = button.getAttribute('data-wishlist-product-url')
        const productMaterial = button.getAttribute('data-wishlist-product-material')
        const productPrice = button.getAttribute('data-wishlist-product-price')
        const productImage = button.getAttribute('data-wishlist-product-image')

        if (this.productIdData.includes(productId)) {
          if (window.localStorage.getItem('wishlist-ids').split(',').length <= 1) {
            this.productIdData = ''
            this.productTitleData = ''
            this.productUrlData = ''
            this.productMaterialData = ''
            this.productPriceData = ''
            this.productImageData = ''
          } else {
            this.productIdData = window.localStorage.getItem('wishlist-ids').replace(`${productId},`, '')
            this.productTitleData = window.localStorage.getItem('wishlist-titles').replace(`${productTitle},`, '')
            this.productUrlData = window.localStorage.getItem('wishlist-urls').replace(`${productUrl},`, '')
            this.productMaterialData = window.localStorage.getItem('wishlist-materials').replace(`${productMaterial},`, '')
            this.productPriceData = window.localStorage.getItem('wishlist-prices').replace(`${productPrice},`, '')
            this.productImageData = window.localStorage.getItem('wishlist-images').replace(`${productImage},`, '')
          }
        }
        window.localStorage.setItem('wishlist-ids', this.productIdData)
        window.localStorage.setItem('wishlist-titles', this.productTitleData)
        window.localStorage.setItem('wishlist-urls', this.productUrlData)
        window.localStorage.setItem('wishlist-materials', this.productMaterialData)
        window.localStorage.setItem('wishlist-prices', this.productPriceData)
        window.localStorage.setItem('wishlist-images', this.productImageData)

        if (isNowEmpty()) {
          this.renderEmptyContent(true)
        }

        this.updateBubbleCount()
        this.updateHeartStatuses()
      })
    })
  }

  renderLineItem (productId, productTitle, productUrl, productMaterial, productPrice, productImage) {
    return (`<tr class="wishlist-item" role="row" style="display: block; width: 100%;">
        <td class="wishlist-item__media" role="cell" headers="WishlistDrawer-ColumnProductImage">
          <a href="${ productUrl }" class="wishlist-item__link" tabindex="-1" aria-hidden="true">
            <img
              class="wishlist-item__image"
              src="${ productImage }"
              alt=""
              loading="lazy"
              width="150"
              height="150"
            >
          </a>
        </td>

        <td class="wishlist-item__details" role="cell" headers="WishlistDrawer-ColumnProduct">
          <a href="${ productUrl }" class="cart-item__name h5 break">
            ${ productTitle }
          </a>

          <div class="wishlist-item__price-and-quantity">
            <div class="wishlist-item__price-wrapper">
              <p class="material">
                ${ productMaterial }
              </p>
              <form method="post" action="/cart/add">
                <input type="hidden" name="id" value="${ productId }" />
                <input class="visually-hidden" id="quantity" name="quantity" value="1" />
                <input type="submit" value="Add to cart" class="button button--text-link" />
              </form>
              <p class="price price--end">
                ${ productPrice }
              </p>
            </div>
          </div>
        </td>

        <td class="wishlist-item__remove">
          <wishlist-remove-button
            id="Remove-{{ item.index | plus: 1 }}"
            data-index="{{ item.index | plus: 1 }}"
            data-wishlist-remove
            data-wishlist-product-id="${ productId }"
            data-wishlist-product-title="${ productTitle }"
            data-wishlist-product-url="${ productUrl }"
            data-wishlist-product-material="${ productMaterial }"
            data-wishlist-product-price="${ productPrice }"
            data-wishlist-product-image="${ productImage }"
            >
            <div href="${ productUrl }" class="item-delete-tray" aria-label="Remove ${ productTitle } from wishlist">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
                class="icon icon-close"
                fill="none"
                viewBox="0 0 18 17"
              >
                <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
              </svg>
            </div>
          </wishlist-remove-button>
        </td>
      </tr>
    `)
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('wishlist-drawer', WishlistDrawer);
